export default {
    getSelectedPath(state) {
        return state.selectedPath;
    },
    getPermissionOfSelectedBin(state) {
        return state.binPermission;
    },
};